// -----------------------------------------------------------------------------
// Firebase — Initialisation centralisée
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";

// --- Configuration -----------------------------------------------------------
// ⚠️  À terme, déplacer ces valeurs dans un fichier .env :
//     REACT_APP_FIREBASE_API_KEY=...
//     puis : apiKey: process.env.REACT_APP_FIREBASE_API_KEY
const firebaseConfig = {
  apiKey: "AIzaSyAbpTCASyed5LpwI3Nr3I9hGeb0Mlq0nuY",
  authDomain: "stockpro-visualispro.firebaseapp.com",
  projectId: "stockpro-visualispro",
  storageBucket: "stockpro-visualispro.firebasestorage.app",
  messagingSenderId: "880490783420",
  appId: "1:880490783420:web:c8c43ca3b52affe30ca6b9",
  measurementId: "G-G1C1NGB8KY",
};

// --- Initialisation ----------------------------------------------------------
const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);

// --- Persistance hors-ligne --------------------------------------------------
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === "failed-precondition") {
    console.log("Persistance impossible : plusieurs onglets ouverts");
  } else if (err.code === "unimplemented") {
    console.log("Persistance non supportée sur ce navigateur");
  }
});

// --- Noms de collections Firestore -------------------------------------------
export const PRODUCTS_COL = "products";
export const HISTORY_COL = "history";
export const USERS_COL = "users";
export const PERTES_COL = "pertes_logs";

export default firebaseApp;
